import React from 'react';
import { Link } from 'react-router-dom';

function Navbar(){
    return(
        <div className='Navbar'>
            <Link className="nav-link" to='/'><div className='logo'>ExerTracker</div></Link>
            {/* <div className='seperator'>|</div> */}
            <ul className='nav-list'>
                <li>
                    <Link className="nav-link" to='/'>Exercises</Link>
                </li>
                <li>
                    <Link className="nav-link" to='/create'>Create Exercise Log</Link>
                </li>
                <li>
                    <Link className="nav-link" to='/user'>Create User</Link>
                </li>
            </ul>
        </div>
    )
}

export default Navbar;